import soundCorrect from '../../src/assets/sound/sound-correct.wav';

/**
 * @author Karen Yunuen Pozos Arias
 * @jobTitle Full Stack Developer - IBL
 * @email kpozos@ibl.mx
 *
 * Class representing a sound player that handles user interaction
 * restrictions for autoplay in browsers.
 */
class SoundPlayer {
    /**
     * Creates a SoundPlayer instance.
     * Initializes the audio element and sets up event listeners
     * to unlock audio playback on first user interaction.
     */
    constructor() {
        /**
         * Audio element for the sound effect.
         * @type {HTMLAudioElement}
         */
        this.audio = new Audio(soundCorrect);

        /**
         * Flag indicating whether audio playback is allowed.
         * @type {boolean}
         */
        this.canPlay = false;

        /**
         * Unlocks audio playback after the first user interaction.
         * @private
         * @function
         */
        const unlock = () => {
            this.canPlay = true;

            document.removeEventListener('click', unlock);
            document.removeEventListener('keydown', unlock);
            document.removeEventListener('touchstart', unlock);
        };

        // Add event listeners for first user interaction
        document.addEventListener('click', unlock);
        document.addEventListener('keydown', unlock);
        document.addEventListener('touchstart', unlock);
    }

    /**
     * Plays the sound from the start if playback has been unlocked.
     * Does nothing if `canPlay` is false.
     * @public
     */
    play() {
        if (!this.canPlay) return;
        this.audio.currentTime = 0;
        this.audio.play().catch(() => {});
    }
}

/**
 * Singleton instance of SoundPlayer.
 * @type {SoundPlayer}
 */
const playSound = new SoundPlayer();

export default playSound;
